import { render, staticRenderFns } from "./UndoIcon.vue?vue&type=template&id=724a75e0"
import script from "./UndoIcon.vue?vue&type=script&lang=js"
export * from "./UndoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports